import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // We need to access the wrapper to toggle the class
  static targets = ["wrapper"]
  
  // We define the class name here so it's reusable
  static classes = ["open"]

  toggle(event) {
    event.preventDefault()
    
    // Toggle the 'open' (or 'expanded') class on the wrapper
    this.wrapperTarget.classList.toggle(this.openClass)
  }
}
